// Google Drive link handling: Drive "file" links can be converted to a
// directly-renderable thumbnail URL. Drive "folder" links can never render
// as an image — callers should show a placeholder + a "View on Drive" link.

export function extractDriveFileId(url) {
  if (!url) return null;
  const match = url.match(/drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)/);
  return match ? match[1] : null;
}

export function isDriveFolderLink(url) {
  return !!url && /drive\.google\.com\/drive\/folders\//.test(url);
}

export function resolveImageUrl(url) {
  if (!url) return null;
  const fileId = extractDriveFileId(url);
  if (fileId) return `https://drive.google.com/thumbnail?id=${fileId}&sz=w1600`;
  if (isDriveFolderLink(url)) return null;
  return url;
}
